import React from "react";
import { useParams } from "react-router-dom";  // ✅ 引入 useParams
import StructureViewer from "./StructureViewer";
import MaterialProperties from "./MaterialProperties";
import BdosViewer from "./bdos_viewer";
import PdosViewer from "./pdos_viewer";

const MaterialDetailPage = () => {
  const { materialId } = useParams();  // ✅ 从 URL 读取参数

  return (
    <div className="container">
      <h1>Material Details</h1>
      <p>Material ID: {materialId || "未找到材料ID"}</p>  {/* ✅ 避免 undefined */}

      {/* 晶体结构可视化 */}
      <StructureViewer materialId={materialId} />

      {/* 材料属性 */}
      <MaterialProperties materialId={materialId} />
      {/*<BdosViewer materialId={materialId} />*/}

    </div>
  );
};

export default MaterialDetailPage;
